import React, { Component } from 'react';
import Dashboard from '../dashboard/Dashboard';
import Header from '../header/Header';
import moment from 'moment';

class Wrapper extends Component {



    state = {
        year2 : 0,
        week2 : 0,
        weeksAverageProdUrl : 'https://hanna-sprint-api.herokuapp.com/hannasprint/getWeeksAverage/',
        bestDayProdUrl : `https://hanna-sprint-api.herokuapp.com/hannasprint/getBestDay/`,
        bestThreeWeeksProdUrl : `https://hanna-sprint-api.herokuapp.com/hannasprint/getTopThreeWeeks/`,
        weeksAverageDevUrl : 'http://localhost:3000/hannasprint/getWeeksAverage/',
        bestDayDevUrl : `http://localhost:3000/hannasprint/getBestDay/`,
        bestThreeWeeksDevUrl : `http://localhost:3000/hannasprint/getTopThreeWeeks/`,
    }

    
    getWeekDays(weekStart) {
        const days = [weekStart];
        for (let i = 1; i < 7; i += 1) {
          days.push(
            moment(weekStart)
              .add(i, 'days')
              .toDate()
          );
        }
        return days;
      }
      
    getWeekRange(date) {
        return {
          from: moment(date)
            .startOf('isoWeek')
            .toDate(),
          to: moment(date)
            .endOf('isoWeek')
            .toDate(),
        };
      }

      componentDidMount() {
        console.log(moment(new Date()).year());
        console.log(moment(new Date()).week());
        this.setState({
          selectedDays: this.getWeekDays(this.getWeekRange(new Date()).from),
          year2: moment(new Date()).year(),
          week2: moment(new Date()).isoWeek()
        });
      }
  

    handleGetBestWeek = (year, week) => {
        let yearTemp = moment().day("Monday").year(year).week(week +1).toDate();
        var test = this.getWeekDays(this.getWeekRange(yearTemp).from);
        //console.log(yearTemp.format('YYYY-MM-DD'));
        this.setState({
            year2 : year,
            week2 : week,
            selectedDays : test
        })
    }

    handleGetBestDay = (date) => {
      console.log(date);
      let properDate = moment(date);
      this.setState({
        year2: moment(properDate).year(),
        week2: moment(properDate).week(),
        selectedDays: this.getWeekDays(this.getWeekRange(properDate).from)
      });
    }

    handleWeekChange = (year, week) => {
        this.setState({
            year2: year,
            week2 : week
        })
    }

    render() {
        return (
            <div>
                <Header handleGetBestWeek={this.handleGetBestWeek} handleGetBestDay={this.handleGetBestDay} year2={this.state.year2} week2={this.state.week2}/>
                <Dashboard 
                    handleGetBestWeek={this.handleGetBestWeek}
                    year2={this.state.year2} 
                    week2={this.state.week2}
                    selectedDays={this.state.selectedDays}
                    handleWeekChange={this.handleWeekChange}/>
            </div>
        );
    }
}

export default Wrapper;
